var _span, _Glyphicon, _div, _hr, _WalletHeaderBadge, _HeaderBadgeTrigger;
import React, { useState } from 'react';
import PropTypes from 'prop-types';
import clsx from 'clsx';
import { useFeatures } from '@atc/features';
import { AdvertisementText, Glyphicon, PopoverSheet, Text, Image, Button, AccessibilityUtilities, Link, Label } from 'reaxl';
import { useDevice } from '@atc/react-device';
import { HeaderBadgeTrigger } from 'reaxl-header-badge';
import { WalletHeaderBadge } from 'reaxl-wallet';
import { header } from 'axl-config';
import HeaderBrand from '../HeaderBrand';
import HeaderSlidingMenu from '../HeaderSlidingMenu';
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
const {
  navItems,
  getConsolidatedNavItems,
  brand,
  sponsoredContent,
  consolidatedSponsoredContent
} = header;

// Custom component to swallow active prop to avoid react console warnings
function NavDropdownSection(_ref) {
  let {
    active,
    children,
    className,
    ...rest
  } = _ref;
  return /*#__PURE__*/_jsx("div", {
    className: clsx('submenu-links', className),
    ...rest,
    children: children
  });
}
function NavItem(_ref2) {
  let {
    itemData,
    onClick,
    text,
    section,
    onEventKey,
    eventkey,
    linkContext,
    className,
    aClassName,
    isBeta,
    isOffsite,
    glyphOverride,
    glyph,
    ...rest
  } = _ref2;
  const data = itemData;
  const handleNavItemClick = e => {
    onClick(e, data);
    return true;
  };
  return /*#__PURE__*/_jsx("li", {
    className: className,
    children: /*#__PURE__*/_jsxs("a", {
      ...rest,
      ...(onClick && {
        onClick: handleNavItemClick
      }),
      className: aClassName,
      children: [text, isBeta && (_span || (_span = /*#__PURE__*/_jsx("span", {
        className: "beta-label-wrapper",
        children: /*#__PURE__*/_jsx(Label, {
          bsStyle: "brand",
          className: "beta-label",
          children: "Beta"
        })
      }))), isOffsite && (_Glyphicon || (_Glyphicon = /*#__PURE__*/_jsx(Glyphicon, {
        glyph: "offsite",
        className: "margin-left-1 text-size-300 offsite-icon"
      })))]
    })
  }, `${text}-${eventkey}`);
}
const renderHeaderItem = (onClick, data) => /*#__PURE__*/_jsx(NavItem, {
  itemData: data,
  onClick: onClick,
  ...data
}, data.eventkey);
const renderDropdownHeaderItem = _ref3 => {
  let {
    text,
    ...rest
  } = _ref3;
  return /*#__PURE__*/_jsx("li", {
    className: "submenu-header",
    ...rest,
    children: /*#__PURE__*/_jsx("h5", {
      children: text
    })
  }, text.replace(' ', ''));
};
const handlePartnerClick = function (event, details, linkContext, onClick, openToNewWindow) {
  if (openToNewWindow === void 0) {
    openToNewWindow = true;
  }
  event.stopPropagation();
  event.preventDefault();
  onClick(event, {
    ...details,
    linkContext
  });
  if (openToNewWindow) {
    window.open(details.link.href);
  } else {
    window.location.href = details.link.href;
  }
};
const getSponsoredContent = function (headerSponsoredContent, onClick, isSlidingMenu) {
  if (isSlidingMenu === void 0) {
    isSlidingMenu = false;
  }
  return headerSponsoredContent.map((details, index) => {
    const {
      sponsoredText,
      partner,
      partnerType,
      image,
      link,
      openToNewWindow,
      ...rest
    } = details;
    const {
      src,
      alt,
      width,
      height,
      loading,
      lazyload
    } = image;
    const {
      href,
      label
    } = link;
    delete rest.onEventKey;
    const handleImageClick = e => {
      handlePartnerClick(e, details, 'PartnersTileClick', onClick, openToNewWindow);
    };
    const handleLinkClick = e => {
      handlePartnerClick(e, details, 'PartnersCTAClick', onClick, openToNewWindow);
    };
    return /*#__PURE__*/_jsxs("div", {
      className: clsx('display-flex align-items-center', {
        'margin-top-5': isSlidingMenu
      }),
      "data-cmp": "sponsored-content",
      children: [/*#__PURE__*/_jsx("a", {
        className: "margin-right-4 padding-3 display-flex justify-content-center align-items-center bg-brand-primary rounded-full header-sponsored-image-link flex-shrink-0",
        onClick: handleImageClick,
        href: href,
        children: /*#__PURE__*/_jsx(Image, {
          src: src,
          alt: alt,
          width: width,
          height: height,
          loading: loading,
          lazyload: lazyload
        })
      }), /*#__PURE__*/_jsxs(Text, {
        componentClass: "div",
        size: 200,
        className: "margin-right-2 margin-bottom-2",
        children: [sponsoredText && /*#__PURE__*/_jsx(AdvertisementText, {
          componentClass: "div",
          children: sponsoredText
        }), /*#__PURE__*/_jsx(Link, {
          undecorated: !isSlidingMenu,
          "data-cmp": "sponsor-link",
          href: href,
          onClick: handleLinkClick,
          children: label
        })]
      })]
    }, `${partnerType}${partner}${index}`);
  });
};
const renderHeaderDropDownColumn = (_ref4, onClick) => {
  let {
    active,
    items,
    ...rest
  } = _ref4;
  const columnProps = {
    ...rest
  };
  delete columnProps.active;
  return /*#__PURE__*/_jsxs("ul", {
    className: "list-unstyled",
    children: [columnProps.text && renderDropdownHeaderItem({
      ...columnProps
    }), items.map(item => {
      const {
        ...itemRest
      } = item;
      const itemClone = {
        ...itemRest,
        linkContext: 'CarResearchLinks',
        aClassName: 'link-undecorated'
      };
      return renderHeaderItem(onClick, itemClone);
    })]
  }, columnProps.text);
};
function renderNavDropdown(navDropdownItem, headerSponsoredContent, onClick, onSponsorContentReady, showSubmenu, setShowSubmenu) {
  const {
    items,
    text,
    eventkey,
    showSponsoredContentSeperator = true,
    sponsoredContentLayout = 'horizontal',
    popoverWidth
  } = navDropdownItem;
  const key = text.replace(' ', '');
  const isOpen = showSubmenu === eventkey;

  // Filter sponsored content by eventkey
  const dropdownSponsoredContent = headerSponsoredContent?.filter(sponsor => sponsor.eventkey === eventkey) || [];
  let readyToFireImpression = true;
  const impressionHandler = e => {
    const delay = 1000;
    const dropDown = document?.querySelector('.nav .popover-submenu');
    const isWindowHelper = window && window.getComputedStyle !== undefined;
    setTimeout(() => {
      if (dropDown && isWindowHelper && window.getComputedStyle(dropDown).display === 'block' && readyToFireImpression) {
        dropdownSponsoredContent.forEach(sponsor => {
          if (sponsor.sponsoredText || sponsor.enableTriggerSponsorImpression) {
            onSponsorContentReady(e, sponsor);
          }
        });
      }
      readyToFireImpression = false;
    }, delay);
  };
  const handleOnHide = () => setShowSubmenu(null);
  const handleOnDropdownClick = e => {
    e.preventDefault();
    setShowSubmenu(prev => prev === eventkey ? null : eventkey);
    if (!isOpen) {
      impressionHandler(e);
    }
    // Sends Analytics event for Sell or Trade-In click
    if (text === 'Sell or Trade-In') {
      onClick(e, {
        linkContext: 'HeaderNav',
        text,
        onEventKey: 'sellOrTradeInDropdown'
      });
    }
  };
  return /*#__PURE__*/_jsxs("li", {
    children: [/*#__PURE__*/_jsxs(Button, {
      bsStyle: "link",
      id: `submenuCta-${eventkey}`,
      "aria-expanded": isOpen,
      onClick: handleOnDropdownClick,
      children: [text, /*#__PURE__*/_jsx(Glyphicon, {
        glyph: `chevron-${isOpen ? 'up' : 'down'}`,
        className: "text-size-300 margin-left-1 icon"
      })]
    }), /*#__PURE__*/_jsxs(PopoverSheet, {
      show: isOpen,
      role: "menu",
      onHide: handleOnHide,
      className: "popover-submenu",
      position: "center",
      containerElement: _div || (_div = /*#__PURE__*/_jsx("div", {})),
      renderServerSide: true,
      popoverTriggerId: `submenuCta-${eventkey}`,
      useBottomSheet: false,
      ...(popoverWidth && {
        style: {
          width: `${popoverWidth}px`
        }
      }),
      children: [items && items.length > 0 && /*#__PURE__*/_jsx(NavDropdownSection, {
        children: items.map(item => renderHeaderDropDownColumn({
          ...item
        }, onClick))
      }), dropdownSponsoredContent && dropdownSponsoredContent.length > 0 && /*#__PURE__*/_jsxs(React.Fragment, {
        children: [showSponsoredContentSeperator && (_hr || (_hr = /*#__PURE__*/_jsx("hr", {
          className: "display-none display-md-block"
        }))), /*#__PURE__*/_jsx("div", {
          className: clsx('sponsored-container display-flex', {
            'flex-column': sponsoredContentLayout === 'vertical',
            'flex-row': sponsoredContentLayout === 'horizontal',
            'margin-top-0': !items || items.length === 0
          }),
          children: getSponsoredContent(dropdownSponsoredContent, onClick)
        })]
      }, "popover-sponsored-content-section")]
    })]
  }, `${key}-${eventkey}`);
}
const renderNavigationItem = (item, headerSponsoredContent, onClick, onSponsorContentReady, showSubmenu, setShowSubmenu) => {
  if (item.items) {
    return renderNavDropdown(item, headerSponsoredContent, onClick, onSponsorContentReady, showSubmenu, setShowSubmenu);
  }
  const {
    ...rest
  } = item;
  return renderHeaderItem(onClick, {
    ...rest
  });
};
function Header(_ref5) {
  let {
    brand: headerBrand = brand,
    headerContent,
    navItems: propNavItems,
    sponsoredContent: propSponsoredContent,
    className,
    showWallet = false,
    enableWalletPopover = false,
    showHeaderBadge = true,
    onClick = () => {},
    onSponsorContentReady = () => {},
    ...rest
  } = _ref5;
  const [showSubmenu, setShowSubmenu] = useState(null);
  const [isSlidingMenuOpen, setIsSlidingMenuOpen] = useState(false);
  const device = useDevice();
  const isLessThanLg = device?.lessThan?.lg ?? false;

  // atc_nav_experience flag with multiple variants.
  const {
    atc_nav_experience: [isNewNavEnabled, {
      control,
      consolidated
    } = {}],
    enable_atc_nav_ai_mode_link: [showAiModeLink],
    ai_assistant_entry_point: [{
      destination: aiEndpoint
    }]
  } = useFeatures(['atc_nav_experience', 'enable_atc_nav_ai_mode_link', 'ai_assistant_entry_point']);
  const useConsolidatedNav = isNewNavEnabled && consolidated && !control;
  const headerNavItems = propNavItems || (useConsolidatedNav ? getConsolidatedNavItems(showAiModeLink, aiEndpoint) : navItems);
  const headerSponsoredContent = propSponsoredContent || (useConsolidatedNav ? consolidatedSponsoredContent : sponsoredContent);
  const handleSlidingMenuOpen = () => {
    // disable scroll on document body while sliding menu is open
    document?.body?.classList?.add('sliding-menu-open');
    setIsSlidingMenuOpen(true);
  };
  const handleSlidingMenuClose = () => {
    // enable scroll on document body while sliding menu is closed
    document?.body?.classList?.remove('sliding-menu-open');
    setIsSlidingMenuOpen(false);
  };
  return /*#__PURE__*/_jsx("header", {
    "data-cmp": "header",
    ...rest,
    className: clsx('navbar navbar-default', className),
    children: /*#__PURE__*/_jsx("div", {
      className: "container-lg",
      children: /*#__PURE__*/_jsxs("div", {
        className: "navbar-wrapper",
        children: [/*#__PURE__*/_jsx(HeaderBrand, {
          onClick: onClick,
          children: headerBrand(className?.includes('transparent-header'))
        }), /*#__PURE__*/_jsxs("div", {
          className: "header-content",
          children: [/*#__PURE__*/_jsx("div", {
            className: "display-none header-badge",
            children: /*#__PURE__*/_jsxs("span", {
              className: "display-flex align-items-center",
              children: [showWallet && (_WalletHeaderBadge || (_WalletHeaderBadge = /*#__PURE__*/_jsx(WalletHeaderBadge, {}))), showHeaderBadge && (_HeaderBadgeTrigger || (_HeaderBadgeTrigger = /*#__PURE__*/_jsx(HeaderBadgeTrigger, {})))]
            })
          }), headerContent]
        }), isLessThanLg && /*#__PURE__*/_jsxs(_Fragment, {
          children: [/*#__PURE__*/_jsx("label", {
            htmlFor: "navbar-toggle",
            className: "navbar-toggle sr-hidden cursor-pointer",
            children: /*#__PURE__*/_jsx(Glyphicon, {
              tabIndex: 0,
              glyph: "list-view",
              className: "text-size-500",
              onClick: handleSlidingMenuOpen,
              onKeyDown: AccessibilityUtilities.withKeyboardAccessibility(handleSlidingMenuOpen)
            })
          }), /*#__PURE__*/_jsx("input", {
            id: "navbar-toggle",
            className: "sr-hidden hidden",
            type: "checkbox",
            "aria-expanded": isSlidingMenuOpen,
            "aria-label": "toggle navigation menu"
          })]
        }), !isLessThanLg && /*#__PURE__*/_jsx("nav", {
          "data-cmp": "headerDesktopNav",
          className: "navbar-collapse",
          children: /*#__PURE__*/_jsx("ul", {
            className: "nav navbar-nav",
            children: headerNavItems.map(item => renderNavigationItem(item, headerSponsoredContent, onClick, onSponsorContentReady, showSubmenu, setShowSubmenu))
          })
        }), isLessThanLg && /*#__PURE__*/_jsx(HeaderSlidingMenu, {
          navItems: headerNavItems,
          sponsoredContent: headerSponsoredContent,
          isSlidingMenuOpen: isSlidingMenuOpen,
          handleSlidingMenuClose: handleSlidingMenuClose,
          getSponsoredContent: getSponsoredContent,
          onClick: onClick,
          onSponsorContentReady: onSponsorContentReady
        })]
      })
    })
  });
}
export default Header;
export { getSponsoredContent };